import React, { useState, useEffect } from 'react';
import AdminSidebar from './Sidebar/AdminSidebar';
import AdminHeader from './Header/AdminHeader';
import './AdminLayout.css';
import { checkTokenExpiry } from '../utiles/auth';
import { useNavigate } from 'react-router-dom';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    // Get saved state from localStorage, default to false if not found
    const saved = localStorage.getItem('sidebarOpen');
    return saved ? JSON.parse(saved) : false;
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


  const navigate = useNavigate();

  useEffect(() => {
    const expiry = localStorage.getItem("adminTokenExpiry");

    if (!expiry) {
      navigate("/admin/login");
      return;
    }

    const remainingTime = expiry - Date.now();

    if (remainingTime <= 0) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminTokenExpiry");
      navigate("/admin/login");
      return;
    }

    const timer = setTimeout(() => {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminTokenExpiry");
      navigate("/admin/login");
    }, remainingTime);

    return () => clearTimeout(timer);
  }, [navigate]);

  useEffect(() => {
    // Save sidebar state to localStorage whenever it changes
    localStorage.setItem('sidebarOpen', JSON.stringify(sidebarOpen));
  }, [sidebarOpen]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Close sidebar when switching to mobile
      if (mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}

      <AdminSidebar
        isOpen={sidebarOpen}
        onToggle={toggleSidebar}
        isMobile={isMobile}
      />

      <div className="admin-layout-main">
        <AdminHeader onMenuClick={toggleSidebar} />
        <main className="admin-layout-content" onClick={closeSidebar}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;